import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Sora video and stills generation" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">Sora</h2>

        <div className="grid grid-cols-2 gap-12 mt-8">
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold mb-4">Videos</h3>
            <div className="space-y-2">
              <p>• Video's genereren uit tekst</p>
              <p>• Stills</p>
              <p>• Storyboards</p>
              <p>• Image refs van image tool of Midjourney</p>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-2xl font-semibold mb-4">Images</h3>
            <div className="space-y-2">
              <p>• Beste prompt begrip</p>
              <p>• Edits</p>
              <p>• Image refs edits</p>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};
